import styled from 'styled-components';

export const PageWrapper = styled.div`
  padding: 50px 30px;
  background-color: ${props => props.theme.colors.LIGHT_GREY};
  height: calc(100% - 60px);
`;
